import { get } from './client'

export interface PricingEntry {
  model_name: string
  description?: string
  icon?: string
  tags?: string
  vendor_id?: number
  vendor_name?: string
  vendor_icon?: string
  vendor_description?: string
  quota_type?: number
  model_ratio?: number
  model_price?: number
  owner_by?: string
  completion_ratio?: number
  cache_ratio?: number
  create_cache_ratio?: number
  image_ratio?: number
  audio_ratio?: number
  audio_completion_ratio?: number
  enable_groups?: string[]
  supported_endpoint_types?: string[]
  bind_channels?: number[]
  pricing_version?: string
}

export interface PricingVendor {
  id: number
  name: string
  description?: string
  icon?: string
}

export interface SupportedEndpointInfo {
  name?: string
  description?: string
  type?: string
  [key: string]: unknown
}

export interface PricingResponse {
  success?: boolean
  message?: string
  data: PricingEntry[]
  group_ratio: Record<string, number>
  usable_group: Record<string, string>
  vendors?: PricingVendor[]
  auto_groups?: string[]
  supported_endpoint?: Record<string, SupportedEndpointInfo>
  supported_endpoints?: string[]
  pricing_version?: string
}

/**
 * 获取模型定价
 * GET /api/pricing
 */
export async function getPricingApi(): Promise<PricingResponse> {
  const response = await get<PricingResponse>('/api/pricing', undefined, { preserveResponseData: true })
  const vendorMap = new Map((response.vendors || []).map((vendor) => [vendor.id, vendor]))
  response.data = (response.data || []).map((model) => {
    const vendor = model.vendor_id ? vendorMap.get(model.vendor_id) : undefined
    return {
      ...model,
      vendor_name: model.vendor_name || vendor?.name,
      vendor_icon: model.vendor_icon || vendor?.icon,
      vendor_description: model.vendor_description || vendor?.description,
    }
  })
  response.supported_endpoints = response.supported_endpoints || Object.keys(response.supported_endpoint || {})
  return response
}
